<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent="persistent" width="500">
      <v-card rounded="xl">
        <v-card-text class="pt-5 pb-5 pl-5 pr-5 d-flex justify-center">
          <cs-button
            label="Please click to continue your secure session"
            @click="popupLogin"
            left-icon="mdi-security"
            primary
            large
          ></cs-button>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'RefreshToken',
  data() {
    return {
      dialog: false,
      doing: false
    };
  },
  computed: {
    ...mapState({
      interruptRefreshToken: (state) => state.session.interruptRefreshToken,
      idpUri: (state) => state.session.idpUri
    }),
    ...mapGetters({
      authorizationUri: 'session/authorizationUri'
    })
  },
  methods: {
    async popupLogin() {
      if (!this.doing) {
        this.doing = true;

        const refreshUri = `${window.location.origin}/static/refresh.html`;
        const queryParams = `client_id=quicklinks&redirect_uri=${encodeURIComponent(
          refreshUri
        )}&scope=blah&response_type=token&state=`;
        const url = `https://${this.idpUri}/oauth2/authorize?${queryParams}`;

        const height = 500;
        const width = 400;
        const ow = window.open(
          url,
          //          const ow = window.open("http://testschool.localhost:9183/static/test.html#launch",
          'Refresh Session',
          // eslint-disable-next-line no-restricted-globals
          `height=${height},width=${width},left=${(screen.width - width) / 2},top=${
            // eslint-disable-next-line no-restricted-globals
            (screen.height - height) / 2
          },resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes`
        );

        const that = this;

        window.addEventListener('message', function elcb(event) {
          // Do we trust the sender of this message?
          if (event.origin !== window.location.origin && !event.data.includes('access_token'))
            return;
          that.$store.dispatch('session/refresh', {
            uri: event.data,
            refresh: true
          });
          // FYI, hotjar and other things send 'message' so
          // must be sure we get the right one before removing
          window.removeEventListener('message', elcb);
          ow.close();
          that.$store.commit(types.SESSION_SET_INTERRUPT_REFRESH_TOKEN, false);
        });
      }
    }
  },
  watch: {
    interruptRefreshToken(value) {
      switch (value) {
        case true:
          this.dialog = true;
          break;
        default:
          this.dialog = false;
          this.doing = false;
          break;
      }
    }
  }
};
</script>
